import { useLocation, useNavigate } from "react-router-dom";

/**
 * 1NOW-11228: what Back does. The page before when it is one of this site's, so the renter is back where they were
 * (home at the same scroll, or the search results with their filters, location and dates). Home when they landed here
 * from a link, a bookmark or another site: -1 would leave the site, or do nothing in a tab that opened on this page.
 */
export const useBackOrHome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return () => {
    // The router keys every entry it adds; the one the tab opened on is "default".
    let ours = location.key !== "default";
    // A full page load from one of our pages. Not a new tab opened from one: it has nothing to go back to.
    if (!ours && window.history.length > 1) {
      try {
        ours = new URL(document.referrer).origin === window.location.origin;
      } catch {
        ours = false;
      }
    }
    if (ours) navigate(-1);
    else navigate("/");
  };
};
